import { useParams } from "react-router-dom";
import Layout from "../components/Layout";
import LeftSidebar from "../components/LeftSidebar";
import MessageContainer from "../components/MessageContainer";
import IfEmpty from "../components/MessageContainer/Mesaages/IfEmpty";

const Home = () => {
  const { id } = useParams();

  return (
    <Layout>
      <div className="grid sm:grid-cols-1 md:grid-cols-4 h-full">
        <div className="col-span-1">
          <LeftSidebar />
        </div>
        <div className="col-span-3">
          {id ? <MessageContainer /> : <IfEmpty />}
        </div>
      </div>
    </Layout>
  );
};

export default Home;
